import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MiscState {
  tradeTypes: {
    [key: string]: number
  }
  streamTransactions: any[]
}

export const miscSlice = createSlice({
  name: 'misc',
  initialState: {
    tradeTypes: {},
    streamTransactions: [],
  } as MiscState,
  reducers: {
    incrementTradeType: (state, action: PayloadAction<string>) => {
      if (state.tradeTypes[action.payload]) {
        state.tradeTypes[action.payload]++
      } else {
        state.tradeTypes[action.payload] = 1
      }
    },
    addStreamTransaction: (state, action: PayloadAction<any>) => {
      const tempArr = [action.payload, ...state.streamTransactions]
      state.streamTransactions = tempArr
    },
    clearStreamData: (state) => {
      state.streamTransactions = []
      state.tradeTypes = {}
    },
    resetMiscData: (state) => {
      state.streamTransactions = []
      state.tradeTypes = {}
    },
  },
})

export const {
  incrementTradeType,
  addStreamTransaction,
  clearStreamData,
  resetMiscData,
} = miscSlice.actions

export default miscSlice.reducer
